import { StringProperty } from "./StringProperty";

export class EmailProperty extends StringProperty {
  // TODO: eventually put validation here
}
